import React from 'react';

const ImageCollage = () => {
  // Sample images - replace with your actual image URLs

  return (
    <div className="max-w-6xl mx-auto p-4 bg-gray-50">
      <img src="/images/imageCollage.png" alt="Image Collage" className="w-full h-full" />
    </div>
  );
};

export default ImageCollage;
